<script setup lang="ts">
import { PropType, Ref, ref } from 'vue';
import AppButton from './common/app-button.vue';
import Menu, { MenuRouterBindProps } from 'primevue/menu';
import { IAppToolbarButtonItem, IAppToolbarItem } from '../../stores/core/models';
import ContainerToolbarBaseMoreMenuItem from '../toolbars/container-toolbar-base-more-menu-item.vue';

const props = defineProps({
  item: {
    type: Object as PropType<IAppToolbarItem>,
    required: true,
  },
  useBtn: {
    type: Boolean,
    defautl: true,
  },
  menuProps: {
    type: Object as PropType<MenuRouterBindProps>,
  },
});

const menu: Ref<InstanceType<typeof Menu> | undefined> = ref();

const toggleMenu = (event: any) => {
  menu.value!.toggle(event);
};

const onItemClick = (menuItem: IAppToolbarButtonItem) => {
  menu.value?.hide();
  if (props.item.click) props.item.click(menuItem);
};
</script>

<template>
  <app-button
    :icon="item.icon"
    :label="item.label"
    @click.stop="toggleMenu"
    :icon-img="item.iconImg"
    :outlined="!item.isPrimary"
    :severity="item.severity"
    :disabled="item.disabled"
    :tooltip="item.tooltip ? item.tooltip : undefined"
    v-if="useBtn"
  />
  <container-toolbar-base-more-menu-item v-else :item="item" @click.stop="toggleMenu" :menuProps="menuProps" />
  <Menu
    :class="{ 'ml-8': !useBtn }"
    ref="menu"
    id="overlay_menu"
    :model="item.buttonMenuItems"
    :popup="true"
    :ptOptions="{ mergeSections: true, mergeProps: true }"
    :pt="{
      root: 'dark:!bg-black !py-0 ',
      content: 'dark:!bg-black !rounded-lg ',
    }"
  >
    <template #item="{ item, props }">
      <div
        class="flex items-center dark:hover:!bg-gray-800 rounded-md"
        v-ripple
        v-bind="props.action"
        @click.stop="onItemClick(item as IAppToolbarButtonItem)"
      >
        <span class="flex-none">
          <img :src="item.iconImg" v-if="item.iconImg" />
          <span :class="item.icon" v-if="item.icon" />
        </span>
        <span v-if="item.label" class="grow ml-2 text-[14px] font-medium">{{ $t((item as any).label) }}</span>
      </div>
    </template>
  </Menu>
</template>
